export function swiper() {
  const serviceSwiper = new Swiper('.swiper_banner', {
    arrows: true,
    loop: true,
    slidesPerView: 4,
    spaceBetween: 30,
    breakpoints: {
      1281: {
        slidesPerView: 4,
      },
      769: {
        spaceBetween: 15,

      },
      0: {
        spaceBetween: 10,
        slidesPerView: 2,
        speed: 2000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    },
  });
  
  const worksSwiper = new Swiper('.swiper-works', {
    arrows: true,
    loop: true,
    slidesPerView: 3,
    spaceBetween: 55,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

